<div
  class="fixed inset-0 z-[70] flex flex-col bg-black"
  role="dialog"
  aria-modal="true"
  aria-label="Escáner de códigos"
>
  <header class="flex shrink-0 items-center justify-between gap-3 px-4 py-3 text-white">
    <div class="min-w-0">
      <p class="truncate text-sm font-bold">{{ titulo() }}</p>
      <p class="truncate text-xs text-white/60">{{ subtitulo() }}</p>
    </div>

    <div class="flex shrink-0 items-center gap-2">
      @if (linternaDisponible()) {
        <button
          type="button"
          (click)="alternarLinterna()"
          class="rounded-full p-2 text-white transition-colors hover:bg-white hover:text-black"
          [class.bg-white]="linterna()"
          [class.text-black]="linterna()"
          [attr.aria-label]="linterna() ? 'Apagar linterna' : 'Encender linterna'"
        >
          <i class="bi text-lg" [class.bi-lightbulb-fill]="linterna()" [class.bi-lightbulb]="!linterna()"></i>
        </button>
      }

      <button
        type="button"
        (click)="cerrarEscaner()"
        class="rounded-full p-2 text-white transition-colors hover:bg-white hover:text-black"
        aria-label="Cerrar escáner"
      >
        <i class="bi bi-x-lg text-lg"></i>
      </button>
    </div>
  </header>

  <div class="relative min-h-0 flex-1 overflow-hidden bg-black">
    <video
      #video
      class="h-full w-full object-cover"
      autoplay
      muted
      playsinline
      aria-label="Vista de la cámara"
    ></video>

    @if (aviso()) {
      <div
        class="pointer-events-none absolute inset-x-3 top-3 z-10 rounded-xl bg-amber-400/95 px-3 py-2 text-center text-xs font-bold text-black shadow-lg"
        role="status"
        aria-live="polite"
      >
        {{ aviso() }}
      </div>
    }

    @if (error()) {
      <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/85 px-6 text-center text-white"
      >
        <i class="bi bi-camera-video-off text-4xl text-white/70"></i>
        <p class="max-w-xs text-sm font-semibold">{{ error() }}</p>
        <button
          type="button"
          (click)="cerrarEscaner()"
          class="mt-2 rounded-xl bg-white px-4 py-2 text-sm font-bold text-black transition-transform active:scale-95"
        >
          Volver al buscador
        </button>
      </div>
    } @else {
      <div class="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div class="relative h-52 w-[82%] max-w-sm sm:h-64">
          <span class="absolute left-0 top-0 h-9 w-9 rounded-tl-xl border-l-4 border-t-4 border-accent-400"></span>
          <span class="absolute right-0 top-0 h-9 w-9 rounded-tr-xl border-r-4 border-t-4 border-accent-400"></span>
          <span class="absolute bottom-0 left-0 h-9 w-9 rounded-bl-xl border-b-4 border-l-4 border-accent-400"></span>
          <span class="absolute bottom-0 right-0 h-9 w-9 rounded-br-xl border-b-4 border-r-4 border-accent-400"></span>
          <span class="scanner-line absolute left-3 right-3 h-0.5 rounded-full bg-accent-400/90 shadow-[0_0_12px_2px_rgba(52,211,153,0.7)]"></span>
        </div>
      </div>

      @if (cargando()) {
        <div class="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-black/50 text-white">
          <app-progress-spinner strokeWidth="8" size="28" />
          <p class="text-xs text-white/80">Iniciando cámara...</p>
        </div>
      }
    }
  </div>

  <footer class="shrink-0 px-4 pb-6 pt-3 text-center text-white/70">
    @if (ultimoCodigo()) {
      <p class="mb-1 truncate text-xs font-mono text-accent-300">{{ ultimoCodigo() }}</p>
    }
    <p class="text-xs">Mantén el código dentro del marco. Puedes escanear varios seguidos.</p>
  </footer>
</div>
